import 'moment/min/locales';

// import echarts from 'echarts';
import * as echarts from 'echarts';
import { Button, CreateAlert, Icon, InputWraper, useForm } from 'modules';
import moment from 'moment';
import React, { FC, useEffect, useRef, useState } from 'react';
import CustomChart from 'react-apexcharts';
import { useParams } from 'react-router-dom';

import { InputText } from '../../../components';
import { PageHead } from '../../../components/page-head';
import { getLocaleKey } from '../../../languages';
import { AdminService } from '../../../services/admin';

export const UserDetail: FC = () => {
  const params: any = useParams();
  const id = params?.id;

  const [dataUserDetail, setDataUserDetail] = useState<any>(null);
  const [dataTransaction, setDataTransaction] = useState<any>([]);
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const chartRef = useRef<any>(null);

  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    enableReinitialize: true,
    structure: [
      {
        name: 'phoneNumber',
        defaultValue: dataUserDetail?.phoneNumber ?? 'N/A',
        isDisabled: true,
      },
      {
        name: 'fullName',
        defaultValue: dataUserDetail?.fullName ?? 'N/A',
        isDisabled: true,
      },
      {
        name: 'email',
        defaultValue: dataUserDetail?.email ?? 'N/A',
        isDisabled: true,
      },
      {
        name: 'address',
        defaultValue: dataUserDetail?.address ?? 'N/A',
        isDisabled: true,
      },
    ],
    onSubmit: async (values) => {},
  });

  let base = +new Date(1968, 9, 3);
  const oneDay = 24 * 3600 * 1000;
  const date = [];
  const data = [25, 66, 41, 59, 25, 44, 12, 36, 9, 31];
  // let data = [Math.random() * 300];
  for (let i = 1; i < 10; i++) {
    const now = new Date((base += oneDay));
    date.push([now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'));
    // data.push(Math.round((Math.random() - 0.5) * 20 + data[i - 1]));
  }
  const EChartOption = {
    tooltip: {
      trigger: 'axis',
      position: function (pt: any) {
        return [pt[0], '10%'];
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: date,
      show: false,
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, '100%'],
      show: false,
    },
    // dataZoom: [
    //   {
    //     type: 'inside',
    //     start: 0,
    //     end: 10
    //   },
    //   {
    //     start: 0,
    //     end: 10
    //   }
    // ],
    series: [
      {
        name: 'Fake Data',
        type: 'line',
        // symbol: 'none',
        symbol: 'circle',
        showSymbol: false,
        sampling: 'lttb',
        smooth: true,
        itemStyle: {
          color: 'rgb(255, 70, 131)',
          // showSymbol: true,
          symbolSize: 20,
          // symbol: 'circle'
        },
        lineStyle: {
          width: 4,
          // showSymbol: true,
          // symbolSize: 20,
          // symbol: 'circle'
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgb(255, 70, 131)',
            },
            {
              offset: 1,
              color: 'rgb(255, 158, 68)',
            },
          ]),
        },
        emphasis: {
          lineStyle: {
            width: 6,
            opacity: 1,
          },
          itemStyle: {
            borderColor: '#fff',
            // symbol: 'circle',
            // showSymbol: true,
            symbolSize: 10,
            borderWidth: 2,
          },
        },
        data: data,
      },
    ],
  };

  const CustomOptions: any = {
    chart: {
      type: 'area',
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    xaxis: {
      type: 'category',
      categories:
        dataTransaction == null
          ? []
          : dataTransaction?.map((element: any) =>
              moment(element?.createdAt).toISOString(),
            ),
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      grid: {
        show: false,
      },
    },
    grid: {
      show: false, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: false, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      enabled: true,
      x: {
        formatter: function (val: any, opts: any) {
          return `${moment(opts.w.globals.categoryLabels[opts.dataPointIndex])
            .locale(getLocaleKey())
            .format('L HH:mm:ss ([GMT]Z)')}`;
        },
      },
      y: {
        formatter: function (val: any, opts: any) {
          return new Intl.NumberFormat('en').format(val);
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 100],
      },
    },
    colors: ['#00e6b8'],
  };

  const CustomSeries = [
    {
      name: 'Balance',
      data:
        dataTransaction == null
          ? []
          : dataTransaction
              ?.map((element: any) => element?.balanceAfter)
              .reverse(),
    },
  ];

  const handleOnClickToggleLock = () => {
    if (isButtonLoading === true) return;
    AdminService.handleLockUser(
      dataUserDetail?.id,
      dataUserDetail?.isActive === true ? true : false,
    )
      .then(async (res: any) => {
        await AdminService.getUserDetail(id).then((res) =>
          setDataUserDetail(res?.data),
        );
        CreateAlert({ message: 'Successfully!', type: 'success' });
      })
      .catch((err: any) => {
        CreateAlert({ message: err.message, type: 'danger' });
      })
      .finally(() => {
        setIsButtonLoading(false);
      });
  };

  useEffect(() => {
    AdminService.getUserDetail(id).then((res) => {
      AdminService.getListTransactions({
        page: 1,
        pageSize: 10,
        userPhone: res?.data?.phoneNumber,
      }).then((res) => {
        setDataTransaction(res?.data);
      });
      setDataUserDetail(res?.data);
    });

    // const chart = echarts?.init(chartRef?.current);
    // chart.setOption(EChartOption);
  }, []);

  return (
    <div className='container-fluid user-detail'>
      <PageHead title='User Detail' />
      <div className='user-detail-wrapper row'>
        <div className='col-8 primary-info__col'>
          <div className='row'>
            <div style={{ marginBottom: '30px' }} className='col-6'>
              <div className='primary-info__balance'>
                <div className='info__balance__title'>Main Balance</div>
                <div className='info__balance__info'>
                  <div className='info__balance__info__value'>
                    {new Intl.NumberFormat('en').format(
                      dataUserDetail?.balance,
                    )}
                  </div>
                  <div className='info__balance__info__icon'>
                    <Icon.BalanceIcon />
                  </div>
                </div>
                <div className='info__balance__sub-info'>
                  <div className='info__balance__sub-info__title'>
                    UPDATED AT
                  </div>
                  <div className='info__balance__sub-info__value'>
                    {dataTransaction[0]?.createdAt != null
                      ? moment(dataTransaction[0]?.createdAt)
                          .locale(getLocaleKey())
                          .format('L HH:mm:ss ([GMT]Z)')
                      : 'N/A'}
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: '30px' }} className='col-6'>
              {/* <div className="primary-info__balance-chart">
                                <ReactECharts
                                    option={EChartOption}
                                    style={{ width: "100%", height: "309px" }}
                                />
                            </div> */}
              <div className='primary-info__balance-chart'>
                {/* <BalanceChart /> */}
                <div className='primary-info__balance-chart__title'>
                  Balance Last 10 Transactions
                </div>
                <div className='primary-info__balance-chart__chart'>
                  <CustomChart
                    options={CustomOptions}
                    series={CustomSeries}
                    type='area'
                    height='100%'
                  />
                </div>
              </div>
            </div>
            <div className='col-12'>
              <div className='primary-info__general-info'>
                <div className='primary-info__general-info__title'>
                  General information
                </div>
                <div className='primary-info__general-info__field'>
                  <div className='row'>
                    <div className='col-6'>
                      <InputWraper
                        label={'Phone'}
                        inputProps={getInputProps('phoneNumber')}
                        component={InputText}
                      />
                    </div>
                    <div className='col-6'>
                      <InputWraper
                        label={'Name'}
                        inputProps={getInputProps('fullName')}
                        component={InputText}
                      />
                    </div>
                    <div className='col-6'>
                      <InputWraper
                        label={'Email'}
                        inputProps={getInputProps('email')}
                        component={InputText}
                      />
                    </div>
                    <div className='col-6'>
                      <InputWraper
                        label={'Address'}
                        inputProps={getInputProps('address')}
                        component={InputText}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-4 secondary-info__wrapper'>
          <div className='secondary-info'>
            <div className='secondary-info__banner-section'></div>
            <div className='secondary-info__avatar-section'>
              <div className='secondary-info__avatar-section__avatar'>
                <img
                  className={`secondary-info__avatar-section__avatar__img ${
                    dataUserDetail?.avatar == null ? 'image-error' : ''
                  }`}
                  src={dataUserDetail?.avatar ?? '/assets/images/no-image.jpg'}
                  onError={(event: any) => {
                    if (!event.target.classList.contains('image-error')) {
                      event.target.classList.add('image-error');
                    }
                    event.target.src = '/assets/images/no-image.jpg';
                  }}
                  alt=''
                  onClick={(event: any) => {
                    if (event.target.classList.contains('image-error')) return;
                    window.open(dataUserDetail?.avatar, '_blank');
                  }}
                />
              </div>
              <div className='secondary-info__avatar-section__info'>
                <div className='secondary-info__avatar-section__info__name'>
                  {dataUserDetail?.fullName ?? 'N/A'}
                </div>
                <div className='secondary-info__avatar-section__info__phone'>
                  {dataUserDetail?.phoneNumber ?? 'N/A'}
                </div>
              </div>
            </div>
            <div className='secondary-info__lock-section'>
              <div className='secondary-info__lock-section__lock-status'>
                <span
                  className={`secondary-info__lock-section__lock-status__status secondary-info__lock-section__lock-status__status--${
                    dataUserDetail?.isActive === true ? 'active' : 'inactive'
                  }`}
                >
                  {dataUserDetail?.isActive === true
                    ? 'ACCOUNT ACTIVATED'
                    : 'ACCOUNT BLOCKED'}
                </span>
              </div>
              <div className='secondary-info__lock-section__lock-toggle'>
                <Button
                  className='secondary-info__lock-section__lock-toggle__button'
                  onClick={handleOnClickToggleLock}
                  label={
                    dataUserDetail?.isActive === true
                      ? 'Lock User'
                      : 'Unlock User'
                  }
                  buttonType={
                    dataUserDetail?.isActive === true ? 'danger' : 'success'
                  }
                  isLoading={isButtonLoading}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 last-ten-transaction__wrapper'>
          <div className='last-ten-transaction'>
            <div className='last-ten-transaction__primary-title'>
              Last 10 transactions
            </div>
            <div className='Table last-ten-transaction__table'>
              <table>
                <thead className='Table__Head'>
                  <tr>
                    {[
                      'NO',
                      'CREATED DATE',
                      'USER',
                      'AMOUNT',
                      'TYPE',
                      'DESCRIPTION',
                      'TRANSACTION CODE',
                    ].map((element: any, idx: number) => (
                      <th key={idx}>{element}</th>
                    ))}
                  </tr>
                </thead>

                <tbody className='Table__Body'>
                  {dataTransaction?.map((element: any, idx: number) => {
                    return (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>
                          {element?.createdAt != null
                            ? moment(element?.createdAt)
                                .locale(getLocaleKey())
                                .format('L HH:mm:ss')
                            : 'N/A'}
                        </td>
                        <td>
                          <div className='user'>
                            <div className='user__avatar'>
                              <img
                                className={`user__avatar__image ${element?.user?.avatar == null ? 'image-error' : ''}`}
                                src={
                                  element?.user?.avatar ??
                                  '/assets/images/no-image.jpg'
                                }
                                onError={(event: any) => {
                                  if (
                                    !event.target.classList.contains(
                                      'image-error',
                                    )
                                  ) {
                                    event.target.classList.add('image-error');
                                  }
                                  event.target.src =
                                    '/assets/images/no-image.jpg';
                                }}
                                alt=''
                                onClick={(event: any) => {
                                  if (
                                    event.target.classList.contains(
                                      'image-error',
                                    )
                                  )
                                    return;
                                  window.open(element?.user?.avatar, '_blank');
                                }}
                              />
                            </div>
                            <div className='user__info'>
                              <div className='user__info__phone'>
                                {element?.user?.phoneNumber ?? 'N/A'}
                              </div>
                              <div className='user__info__name'>
                                {element?.user?.fullName ?? 'N/A'}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          {new Intl.NumberFormat('en').format(element?.value)}
                        </td>
                        <td>{element?.transactionTypeName ?? 'N/A'}</td>
                        <td>
                          {(element?.description ?? '') != ''
                            ? element?.description
                            : 'N/A'}
                        </td>
                        <td>{element?.transactionCode ?? 'N/A'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {dataTransaction.length === 0 && (
                <div className='Message emptyData'>
                  <Icon.Data />
                  No data
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
